"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation makeSecondaryEmailPrimary($email: String!) {
    makeSecondaryEmailPrimary(email: $email) {
      _id
      firstName
      lastName
      phoneNumber
      secondaryEmails
      email
      __typename
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=makeSecondaryToPrimaryEmail.mutation.js.map